
import React from 'react';
import ProductCard, { Product } from './ProductCard';
import { Shield, Users, Globe } from 'lucide-react';
import { useLanguage } from '@/components/i18n/language-provider';
import { Link } from 'react-router-dom';

const ProductList: React.FC = () => {
  const { t } = useLanguage();
  
  const products: Product[] = [
    {
      id: 'workforce',
      name: t('products.workforce').replace('Keystle', 'KEYSTLE'),
      description: t('products.workforceDesc'),
      features: [
        { name: 'Authentication' },
        { name: 'SSO (Single sign-on)' },
        { name: 'System for cross-domain identity' },
        { name: 'Dynamic authorization' },
        { name: 'Real-time telemetry authentication' },
        { name: 'Multi-tenancy support' },
        { name: 'Logging and auditing' }
      ],
      color: 'pink',
      icon: <Shield className="w-full h-full" />,
      link: '/products/workforce'
    },
    {
      id: 'b2b',
      name: t('products.b2b').replace('Keystle', 'KEYSTLE').replace('B2B', 'Business'),
      description: t('products.b2bDesc'),
      features: [
        { name: 'Unified dashboard' },
        { name: 'Multi-tenant identity management' },
        { name: 'Passwordless authentication' },
        { name: 'Single sign-on (SSO)' },
        { name: 'Adaptive MFA & risk-based access' },
        { name: 'API-first approach' },
        { name: 'Multi-org performance architecture' }
      ],
      color: 'purple',
      icon: <Users className="w-full h-full" />,
      link: '/products/business'
    },
    {
      id: 'ciam',
      name: t('products.ciam').replace('Keystle', 'KEYSTLE'),
      description: t('products.ciamDesc'),
      features: [
        { name: 'Passwordless and social login' },
        { name: 'Adaptive MFA & RBA' },
        { name: 'Seamless omnichannel experience' },
        { name: 'Real-time telemetry and analytics' },
        { name: 'Privacy and compliance-ready' },
        { name: 'Scalable multi-tenant architecture' },
        { name: 'Progressive profiling and personalization' }
      ],
      color: 'b688a4',
      icon: <Globe className="w-full h-full" />,
      link: '/products/ciam'
    },
  ];

  return (
    <div className="py-16">
      <div className="text-center mb-12">
        <span className="inline-block rounded-full px-3 py-1 text-sm bg-primary/10 text-primary font-medium mb-4">
          {t('products.solutions')}
        </span>
        <h2 className="text-3xl font-bold mb-4">{t('products.title')}</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          {t('products.description')}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {products.map((product, index) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
